export const state = {
  goodsreceiving: [],
  goods_order_items: [
    {
      product_id: "",
      product_measurement: "",
      qty: "",
      unit_price: "",
      total_price: "",
      remarks: ""
    }
  ],
  good_receiving_item: [],
  systemGoodreceiving: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/goodsreceiving/state.js